module.exports = __webpack_public_path__ + "static/media/graph.f2d1ba25.png";